import React, { Component } from 'react';
import moment from 'moment';
import { Example, Properties, SourceCode } from 'examples';
import Timepicker from './Timepicker';

import Accordion from '../Accordion/Accordion';

export default class TimepickerExample extends Component {

  constructor() {
    super();
    this.state = {
      selected: moment.utc('2016-12-02T00:00:00'),
      expanded: true,
      utcOffset: 60
    };
  }

  onChange = (date) => {
    this.setState({
      selected: date ? date.clone() : null
    });
  };

  onPropChange = e => {
    this.setState(e.target.value);
  };

  onClick = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={Timepicker.defaultProps} onChange={this.onPropChange} propTypes={Timepicker.propTypes} propValues={this.state}/>
        <Timepicker {...this.state} onSelect={this.onChange} />
        <Accordion onClick={this.onClick} expanded={this.state.expanded} title="Time selected">
          <div>{`Format:  ${this.state.selected ? this.state.selected.clone().utcOffset(this.state.utcOffset).format() : 'null'}`}</div>
          <div>{`Utc:     ${this.state.selected ? this.state.selected.clone().utc().format() : 'null'}`}</div>
        </Accordion>
        <SourceCode language="javascript" title="The onSelect callback">
          {
            '/* For the Timepicker view to be updated the onSelect and selected prop must be implemented. Example: */\n' +
            '\n' +
            'constructor() {\n' +
            '  this.state = { selected: moment() }\n' +
            '}\n' +
            '\n' +
            'onSelect(date) {\n' +
            '  // the date parameter is a moment object\n' +
            '  this.setState({ selected: date })\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<Timepicker onSelect={this.onSelect.bind(this)} selected={this.state.selected}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode querySelector=".core-timepicker"/>
      </Example>
    );
  }

}
